
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Zdroj dat',
	'dataSourceId': 'ID',
	'dataSourceType': 'Typ',
	'dataSourceName': 'Název',
	'dataSourcePath': 'Cesta',
	'showInfoForAll': 'Zobrazit dobu trvání pro všechny vizualizace',
	'hideInfoForAll': 'Skrýt dobu trvání pro všechny vizualizace',
	'showPerformanceDetails': 'Znovu spustit všechny moduly widget, aby zahrnovaly podrobnosti o výkonu',
	'slotMappingField': 'Mapování pozic',
	'slotDataMapping': 'Mapování',
	'slotID': 'ID',
	'slotCaption': 'Titulek',
	'slotMandatory': 'Povinné',
	'slotIsMandatory': 'Ano',
	'slotIsNotMandatory': 'Ne',
	'infoNotAvailable': 'Nedostupný',
	'performanceSection': 'Výkonnost',
	'durationField': 'Trvání',
	'singleQueryTime': 'Dotaz na server (ms)',
	'multipleQueryTime': 'Dotaz na server %{name} (ms)',
	'liveWidgetTotalTime': 'Celkem (ms)',
	'renderTimeNotAvailable': 'Není k dispozici',
	'renderInProgress': '(probíhající)',
	'interactToTriggerQuery': 'Interakce s modulem widget ke spuštění dotazu',
	'fetchQuery': 'Dotaz načtení',
	'showSQLMDX': 'Zobrazit SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informace o dotazu',
	'queryInfoNotAvailable': 'Informace dotazu nejsou k dispozici',
	'query': 'Dotaz',
	'copy': 'Kopírovat',
	'close': 'Zavřít'
});
